import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {SelectItem} from 'primeng/api';

@Component({
  selector: 'app-select-technician-modal',
  templateUrl: './select-technician-modal.component.html',
  styleUrls: ['./select-technician-modal.component.scss']
})
export class SelectTechnicianModalComponent implements OnInit {

  @Input() technicianList;  
  technicians: SelectItem[];
  selectedTechnician: any = {};

  constructor(
    public modal: NgbActiveModal
  ) { 

  }
  ngOnInit(){
    this.technicians = [];
    this.selectedTechnician = {};
    this.technicianList.forEach(technician => {
      this.technicians.push({label: technician.Firstname+" "+technician.Surname, value: technician});
    });
    
  }
  
}

